import { useEffect, useState } from "react";
import CBUtils from "@cb/apricot/CBUtils";
export const useZoomRatio = () => {
    const [zoomRatio, setZoomRatio] = useState(CBUtils.zoomRatio());
    useEffect(() => {
        CBUtils.browserRatio(true);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        document.addEventListener("apricot_browserRatioChange", (event) => {
            var _a;
            setZoomRatio((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.ratio);
        });
    }, []);
    return zoomRatio;
};
//# sourceMappingURL=useZoomRatio.js.map